import React, {CSSProperties, Dispatch, FunctionComponent, SetStateAction} from 'react';
import 'react-mde/lib/styles/css/react-mde-all.css';
import classNames from 'classnames';
import { ChangelogArticle } from '@lfp-digital/back-types-mpg';
import { Separator } from '../Separator';
import { InputLabelEditor } from '../../../../components/InputLabelEditor';

const styles: Record<string, CSSProperties> = {
  inputContainer: {
    marginBottom: 16,
  },
};

export type ArticleEditorMetaDataProps = {
  onChange: (key: string, value: any) => void;
  data: Partial<ChangelogArticle>;
  versions: string[] | undefined;
  version: string | undefined;
  setVersion: Dispatch<SetStateAction<string | undefined>>;
  isCreation?: boolean;
};

export const ArticleEditorMetaData: FunctionComponent<ArticleEditorMetaDataProps> = ({data, onChange, version, setVersion, versions}) => {
  return (
    <div>
      <div style={styles.inputContainer}>
        <InputLabelEditor title="NAME" isRequired />
        <input
          className="form-control"
          value={data?.name || ''}
          onChange={e => onChange('name', e.target.value)}
        />
      </div>
      <Separator />
      <div className="infoWrapper">
        <InputLabelEditor title="VERSION" isRequired />
        <div className={classNames('form-group')}>
          <select
            className="form-control"
            value={version || ''}
            onChange={event =>
              setVersion(event.target.value)
            }>
            <option value=""></option>
            {versions?.map(version => (
              <option key={version} value={version}>
                {version}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Articles/Editor/MetaData/index.tsx